import { render, staticRenderFns } from "./ProfileBar.vue?vue&type=template&id=30ec18a7&"
import script from "./ProfileBar.vue?vue&type=script&lang=js&"
export * from "./ProfileBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports